import {
  AccountActionType,
  EventActionType,
  UserRoleType,
} from "../constants/Enum";

const RolePermission = {
  isAccess: function(role: UserRoleType, actionType: any) {
    switch (actionType) {
      case EventActionType.MyEventView:
      case EventActionType.AddEditEvent:
        switch (role) {
          case UserRoleType.EO:
            return true;
          default:
            return false;
        }
      case EventActionType.EoFinansialReport:
        switch (role) {
          case UserRoleType.EO:
            return true;
          default:
            return false;
        }

      case EventActionType.TicketFinansialReports:
        switch (role) {
          case UserRoleType.EO:
            return true;
          default:
            return false;
        }

      case EventActionType.FeedBack:
        switch (role) {
          case UserRoleType.TRADERRETAILER:
            return true;
          default:
            return false;
        }

      case AccountActionType.ManageSubscription:
        switch (role) {
          case UserRoleType.EO:
            return true;
          default:
            return false;
        }

      case AccountActionType.Units:
        switch (role) {
          case UserRoleType.TRADERRETAILER:
            return true;
          default:
            return false;
        }

      case AccountActionType.BusinessProfile:
        switch (role) {
          case UserRoleType.EO:
          case UserRoleType.MOBILECATERERS:
          case UserRoleType.TRADERRETAILER:
            return true;
          default:
            return false;
        }
      case AccountActionType.PersonalProfile:
        switch (role) {
          case UserRoleType.EO:
          case UserRoleType.MOBILECATERERS:
          case UserRoleType.TRADERRETAILER:
          case UserRoleType.CUSTOMER:
            return true;
          default:
            return false;
        }
      case AccountActionType.Messages:
        switch (role) {
          case UserRoleType.EO:
          case UserRoleType.MOBILECATERERS:
          case UserRoleType.TRADERRETAILER:
            return true;
          default:
            return false;
        }
      case AccountActionType.Notifications:
        switch (role) {
          case UserRoleType.EO:
          case UserRoleType.MOBILECATERERS:
          case UserRoleType.TRADERRETAILER:
            return true;
          default:
            return false;
        }
      case AccountActionType.Reports:
        switch (role) {
          case UserRoleType.EO:
          case UserRoleType.MOBILECATERERS:
          case UserRoleType.TRADERRETAILER:
            return true;
          default:
            return false;
        }
      case AccountActionType.Payout:
        switch (role) {
          case UserRoleType.EO:
            return true;
          default:
            return false;
        }
      case AccountActionType.Payments:
        switch (role) {
          case UserRoleType.MOBILECATERERS:
          case UserRoleType.TRADERRETAILER:
            return true;
          default:
            return false;
        }
      case AccountActionType.ManageApplication:
        switch (role) {
          case UserRoleType.MOBILECATERERS:
          case UserRoleType.TRADERRETAILER:
            return true;
          default:
            return false;
        }
      case AccountActionType.TraderReport:
        switch (role) {
          case UserRoleType.MOBILECATERERS:
          case UserRoleType.TRADERRETAILER:
            return true;
          default:
            return false;
        }
      case EventActionType.ApplyApplication:
        switch (role) {
          case UserRoleType.MOBILECATERERS:
          case UserRoleType.TRADERRETAILER:
            return true;
          default:
            return false;
        }
      case AccountActionType.ShopFront:
        switch (role) {
          case UserRoleType.MOBILECATERERS:
          case UserRoleType.TRADERRETAILER:
            return true;
          default:
            return false;
        }
      case AccountActionType.TraderUnits:
        switch (role) {
          case UserRoleType.MOBILECATERERS:
          case UserRoleType.TRADERRETAILER:
            return true;
          default:
            return false;
        }
      default:
        break;
    }
  },
};

export default RolePermission;
